import { Route } from "@/interfaces/Routes";

export const SiteRoutes: Route = {
  GET_USER_SITES: "/users/{key}/sites",
};
